/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function(event) { 
  var popupRegisterForm = document.querySelector('.popup-register-form');
  var popupLoginForm = document.querySelector('.popup-login-form');
  var popupRegisterToggleButton = document.querySelector('.popup-register-form .for-register-form button');
  var popupLoginToggleButton = document.querySelector('.popup-login-form .for-login-form button');
  
  if (popupRegisterToggleButton != null) {
    popupRegisterToggleButton.addEventListener("click", function(event) {
      if (popupRegisterForm != null && popupLoginForm != null) {
        popupRegisterForm.classList.remove('show');
        popupLoginForm.classList.add('show');
      }
    });
  }
  
  if (popupLoginToggleButton != null) {
    popupLoginToggleButton.addEventListener("click", function(event) {
      if (popupRegisterForm != null && popupLoginForm != null) {
        popupLoginForm.classList.remove('show');
        popupRegisterForm.classList.add('show');
      }
    });
  }
});
// Strip inline font-family from product description spans
document.addEventListener('DOMContentLoaded', function() {
  var selectors = [
    '.product-meta__description span',
    '.product-meta__description p',
    '.product-meta__description td',
    '.product-meta__description b',
    '.product-meta__description i',
    '.accordion-content span',
    '.accordion-content p',
    '.accordion-content td'
  ];
  
  document.querySelectorAll(selectors.join(',')).forEach(function(el) {
    el.style.removeProperty('font-family');
    el.style.removeProperty('font-size');
    el.style.removeProperty('color');
    el.style.removeProperty('mso-fareast-font-family');
  });
});